import { render, staticRenderFns } from "./DownloadedChip.vue?vue&type=template&id=6b3fda91&scoped=true&"
import script from "./DownloadedChip.vue?vue&type=script&lang=js&"
export * from "./DownloadedChip.vue?vue&type=script&lang=js&"
import style0 from "./DownloadedChip.vue?vue&type=style&index=0&id=6b3fda91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3fda91",
  null
  
)

export default component.exports